import './store-password-description.scss'

export const PasswordDescription = () => (
  <div className="store-password-desc">
    <div className="store-password-desc__line">
      ※7〜15文字で半角英数字・記号のうち2種類以上を含む
    </div>
    <div className="store-password-desc__line">
      使用可能な記号：
    </div>
    <div className="store-password-desc__symbols">
      ! @ # $ % ^ & * ( ) - _ = +
    </div>
  </div>
);
